// extracted by mini-css-extract-plugin
module.exports = {"meanings":"Definitions_meanings__3678B","subTitle":"Definitions_subTitle__3j9xh","singleMean":"Definitions_singleMean__4SmeB"};